import { ProductContext } from '@context/ProductProvider';
import { useCurrencyString } from '@hooks/useCurrencyString';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import useTranslation from '@components/Translation/useTranslation';
import Product from '@models/product';

interface Props {
  product: Product;
  dark?: boolean;
}
const EstimatedTotal = ({ dark }: Props) => {
  const { t } = useTranslation();
  const { totalPrice, originalPrice } = React.useContext(ProductContext);
  const getCurrencyString = useCurrencyString();
  return (
    <div
      className={classNames(
        'tw-grid tw-items-center tw-text-center tw-justify-between tw-grid-flow-col',
        dark && 'tw-text-white',
      )}
    >
      <h6 className="tra-text-web-heading-6">
        {t('productDetailPageContent.estimatedTotalText', undefined, {
          default: 'Estimated Total',
        })}
      </h6>
      <h5 className="tw-flex tw-gap-x-2 tra-text-web-body-xl tra-text-web-heading-5 tw-w-auto">
        <span>{getCurrencyString(Number(totalPrice))}</span>
        {totalPrice !== originalPrice && (
          <span className="tw-line-through tw-font-display48 tw-text-surface-450">
            {getCurrencyString(Number(originalPrice))}
          </span>
        )}
      </h5>
    </div>
  );
};

export default EstimatedTotal;
